export default {
  ko_kr: {
    bannerImg: 'ko.png',
    umText: '출시 예정',
    requiredLogin: '이 게임은 로그인이 요구됩니다.',
    jackpotId_1: {
      name: '신비의 보물 잭팟',
      level1Jackpot: '그랜드',
      level2Jackpot: '메가',
      level3Jackpot: '메이저'
    },
    jackpotId_2: {
      name: '푹신한 잭팟',
      level1Jackpot: '메가',
      level2Jackpot: '맥스',
      level3Jackpot: '미니'
    },
    jackpotId_3: {
      name: '골든 리치 잭팟',
      level1Jackpot: '그랜드',
      level2Jackpot: '메이저',
      level3Jackpot: '마이너',
      level4Jackpot: '미니',
    }
  },
};
